<template>
  <q-expansion-item
      v-if="itemsCount > 0 || showEmpty"
      :model-value="expanded"
      v-bind="$attrs"
      switch-toggle-side
      class="expansion"
      :aria-expanded="expanded"
      @click="this.expanded = !this.expanded"
  >
    <template v-slot:header>
      <q-item-section>
        <div class="row items-center" :class="$isMobile ? 'q-gutter-x-sm': 'q-gutter-x-lg'">
          <component :is="headerTag"> {{ label }}</component>
          <count-chip :count="itemsCount" />

          <div class="align">
          <slot name="buttons"/>
          </div>
        </div>
      </q-item-section>
    </template>
    <div
        class="expansion__content"
        role="region"
        tabindex="-1">
      <div>
        <slot />
      </div>
    </div>
  </q-expansion-item>
  <div v-else-if="itemsCount < 1 && $slots.actions" class="row items-center text-weight-medium q-mt-lg q-mb-md">
    <component :is="headerTag">{{ label }} </component>
  </div>
  <slot name="actions" />
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    showEmpty: {
      type: Boolean,
      default: false,
    },
    itemsCount: {
      type: Number,
      default: 0,
    },
    defaultOpened: {
      type: Boolean,
      default: true,
    },
    headerTag: {
      type: String,
      default: 'div',
    },
  },
  data () {
    return {
      expanded: this.defaultOpened,
      promptDialog: false,
    }
  },
}
</script>
